module.exports = __webpack_public_path__ + "208bee8803530e7f78427520c62fc453.png";